import React, { useRef, useEffect } from 'react';
import { createChart } from 'lightweight-charts';
import { priceData } from '../stream/priceData';

function Candles() {
  const chartContainerRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartContainerRef.current) {
      const chartOptions = { 
        layout: { 
          textColor: 'rgba(255, 255, 255, 0.9)', 
          background: { type: 'solid', color: '#101518' } 
        },
        grid: {
          vertLines: {
            color: '#334158',
          },
          horzLines: {
            color: '#334158',
          },
        },
      };

      chartRef.current = createChart(chartContainerRef.current, chartOptions);
      const candlestickSeries = chartRef.current.addCandlestickSeries({
        upColor: '#4bffb5', 
        downColor: '#ff4976', 
        borderDownColor: '#ff4976',
        borderUpColor: '#4bffb5',
        wickUpColor: '#838ca1', 
        wickDownColor: '#838ca1',
      });
      candlestickSeries.setData(priceData);
      chartRef.current.timeScale().fitContent();
    }
    return () => {
      if (chartRef.current) {
        chartRef.current.remove();
      }
    };
  }, []);
  // candlestickSeries.update({ time: '2019-01-01', open: 112, high: 112, low: 100, close: 101 });

  return (
    <div className="widget_body">
      <div className="candles_container no_drag">
        <div ref={chartContainerRef} className="chart_container" />
      </div>
    </div>
  );
}

export default Candles;


// https://codesandbox.io/p/sandbox/tradingview-lightweight-candlestick-9inkb?file=%2Fsrc%2Findex.js